import React, {useEffect, useRef, useState} from "react";
import {ErrorBoundary} from "react-error-boundary";
import {urlHasParam} from "../../utils/js/params";
import Input from "../FormComponents/Input/Input";
import TextArea from "../FormComponents/TextArea/TextArea";
import axios from "axios";


const Text = ({title, name, required, requiredMessage, type, helpMessage, id, hasBlockList, componentPath}) => {

    const [input, setInput] = useState("");
    const [autoFill, setAutoFill] = useState(false);
    const inputRef = useRef(null);
    const searchParams = new URLSearchParams(window.location.search);

    useEffect(() => {
        if (searchParams.get('submit') && !!sessionStorage.getItem(name)) {
            setAutoFill(true);
        }

        let input = inputRef.current;

        if(input){
            if(hasBlockList){
                input.checkBlockListValidity =  async () => {
                    try {
                        await axios.get(`${componentPath}.infios-blocklist.json?mail=${encodeURIComponent(input.value)}`);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
            }

            input.addEventListener('input', function () {
                if (input.checkValidity()) input.classList.remove("error");
                if (input.value) {
                    input.classList.add('has-value');
                } else {
                    input.classList.remove('has-value');
                }
            });
        }
    }, [window.location.search]);

    const getFromStorage = (key) => {
        if (!autoFill) return;
        return sessionStorage.getItem(key) != null ? sessionStorage.getItem(key) : "";
    }
    return <>
        {
            type === 'textarea' ?
                <TextArea
                    name={name}
                    id={id}
                    value={getFromStorage(name)}
                    labelText={title}
                    helpMessage={helpMessage}
                    errorMessage={requiredMessage}
                    required={required}
                    inputRef={inputRef}
                />
                :
                <Input
                    type={type}
                    id={id}
                    noIcon
                    name={name}
                    labelText={title}
                    value={getFromStorage(name)}
                    errorMessage={requiredMessage}
                    validate={setInput}
                    required={required}
                    inputRef={inputRef}
                />
        }

        {requiredMessage &&
            <span className="label-small" style={{color: "#DC3545", display: "none"}}>Select a solution.</span>}
    </>
}

const TextErrors = props => {
    return (
        <ErrorBoundary fallback={props.isInEditor || urlHasParam('wcmmode=disabled') ?
            <div style={{minHeight: '50px', display: 'flex', alignItems: 'center', backgroundColor: '#ffe1db'}}><p>This
                component is currently experiencing errors. Please try again later.</p></div> : <div></div>}>
            <Text {...props} />
        </ErrorBoundary>
    )
}


export default TextErrors;
